import { Button, Flex, Tag } from 'antd'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Components } from 'api/gen/client'
import ConfirmationModal from 'ui/ConfirmationModal/ConfirmationModal'
import useCreateInvoice from '../InvoiceCreate/hooks/useCreateInvoice'
import useDeleteInvoice from './hooks/useDeleteInvoice'
import useInvoiceFormDefaultValues from '../InvoiceForm/useInvoiceFormDefaultValues'
import { InvoiceFormValues } from '../InvoiceForm/schema'

interface InvoiceInfoProps {
  invoice: Components.Schemas.Invoice
}

const InvoiceInfo = ({ invoice }: InvoiceInfoProps) => {
  const navigate = useNavigate()
  const invoiceCopyValues = useInvoiceFormDefaultValues(invoice) as InvoiceFormValues

  const successCallback = () => {
    navigate('/')
  }

  const { createInvoice } = useCreateInvoice({
    onSuccess: successCallback
  })

  const { deleteInvoice } = useDeleteInvoice({
    onSuccess: successCallback
  })

  const copyInvoice = () => {
      createInvoice(invoiceCopyValues)
    }

  const [isCopyModalOpen, setIsCopyModalOpen] = useState<boolean>(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false)

  return (
    <Flex justify="between" gap="1rem">
      <Flex gap="1rem" vertical flex={1}>
        <div>
          <strong>Invoice #:</strong> {invoice.id}
        </div>
        <Flex gap="1rem">
          <Tag color={invoice.paid ? 'green' : 'orange'}>
            {invoice.paid ? 'Paid' : 'Unpaid'}
          </Tag>
          <Tag color={invoice.finalized ? 'blue' : 'orange'}>
            {invoice.finalized ? 'Finalized' : 'Draft'}
          </Tag>
        </Flex>
      </Flex>
      <Flex gap="1rem" vertical flex={1}>
        <div>
          <strong>Issue Date:</strong> {invoice.date || 'N/A'}
        </div>
        <div>
          <strong>Deadline:</strong> {invoice.deadline || 'N/A'}
        </div>
      </Flex>
      <Flex gap="1rem" vertical>
        <Flex gap="1rem">
          <Button type="primary" href={`/invoices/${invoice.id}/edit`}>
            Edit
          </Button>
          <ConfirmationModal 
            isOpen={isCopyModalOpen}
            title="Copy Invoice"
            description="Are you sure you want to create a copy of this invoice?"
            openCallback={setIsCopyModalOpen} 
            confirmCallback={copyInvoice}
          >
            <Button  onClick={() => setIsCopyModalOpen(true)}>Copy</Button>
          </ConfirmationModal>
          <ConfirmationModal 
            isOpen={isDeleteModalOpen}
            title="Delete Invoice"
            description="Are you sure you want to delete this invoice?"
            openCallback={setIsDeleteModalOpen} 
            confirmCallback={() => deleteInvoice(invoice.id)}
          >
            <Button 
              danger 
              disabled={invoice.finalized} 
              onClick={() => setIsDeleteModalOpen(true)}
            >
              Delete
            </Button>
          </ConfirmationModal>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default InvoiceInfo
